import React from 'react';
interface PaxStatementBookingSummaryProps {
  booking: {
    bookingRef: string;
    productName: string;
    tourCode: string;
    departure: string;
    return: string;
    bookingDate: string;
    bookingStaff: string;
    bookingStaffEmail: string;
    paymentReceived: number;
    totalAmount: number;
    balanceDueDate: string;
    currency: string;
  };
}
export function PaxStatementBookingSummary({
  booking
}: PaxStatementBookingSummaryProps) {
  const formatCurrency = (amount: number) => {
    return `${booking.currency} ${amount.toFixed(2)}`;
  };
  return <div className="mb-6 bg-blue-50 border border-blue-200 rounded-lg p-5" data-id="element-696">
      <div className="space-y-3" data-id="element-697">
        {/* Row 1 */}
        <div className="grid grid-cols-4 gap-x-6 gap-y-2" data-id="element-698">
          <div data-id="element-699">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-700">
              Booking Ref:
            </p>
            <p className="text-sm font-bold text-neutral-900" data-id="element-701">
              {booking.bookingRef}
            </p>
          </div>
          <div data-id="element-702">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-703">
              Product Name:
            </p>
            <p className="text-sm font-semibold text-neutral-900" data-id="element-704">
              {booking.productName}
            </p>
          </div>
          <div data-id="element-705">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-706">
              Tour Code:
            </p>
            <p className="text-sm text-neutral-900" data-id="element-707">{booking.tourCode}</p>
          </div>
          <div data-id="element-708">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-709">
              Travel Dates:
            </p>
            <p className="text-sm text-neutral-900" data-id="element-710">
              {booking.departure} - {booking.return}
            </p>
          </div>
        </div>

        <div className="h-px bg-blue-200" data-id="element-711" />

        {/* Row 2 */}
        <div className="grid grid-cols-4 gap-x-6 gap-y-2" data-id="element-712">
          <div data-id="element-713">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-714">
              Booking Date:
            </p>
            <p className="text-sm text-neutral-900" data-id="element-715">{booking.bookingDate}</p>
          </div>
          <div data-id="element-716">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-717">
              Booking Staff:
            </p>
            <p className="text-sm font-semibold text-neutral-900" data-id="element-718">
              {booking.bookingStaff}
            </p>
            <p className="text-xs text-neutral-600 mt-0.5" data-id="element-719">
              {booking.bookingStaffEmail}
            </p>
          </div>
          <div data-id="element-720">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-721">
              Payment:
            </p>
            <p className="text-sm text-neutral-900" data-id="element-722">
              {formatCurrency(booking.paymentReceived)} /{' '}
              {formatCurrency(booking.totalAmount)}
            </p>
          </div>
          <div data-id="element-723">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-724">
              Balance Due Date:
            </p>
            <p className="text-sm font-semibold text-red-600" data-id="element-725">
              {booking.balanceDueDate}
            </p>
          </div>
        </div>
      </div>
    </div>;
}